import React, { useState } from 'react'

import LgyModalDialog from 'app/components/util/lgy-modal-dialog/LgyModalDialog'
import LgyFormSubmit from 'app/components/util/lgy-form-submit/LgyFormSubmit'
import BasicLgyTextArea from 'app/components/util/lgy-text-area/BasicLgyTextArea'

const ReassignmentRequest = ({ show, close, reassign }) => {
    const [reasonText, setReasonText] = useState('')

    const handleSubmit = () => {
        close()
        reassign(reasonText)
        setReasonText('')
    }

    const handleClose = () => {
        setReasonText('')
        close()
    }

    return <LgyModalDialog show={show} onClose={handleClose}>
        <form className='usa-form' onSubmit={handleSubmit}>
            <fieldset className='usa-fieldset-inputs'>
                <legend className='usa-sr-only'>Reason for Reassignment Request</legend>
                <BasicLgyTextArea id='reassignmentReason' label='Reason for request:' placeholder='Note Text' maxLength='4000' required
                    name='reasonText' value={reasonText} onChange={(event) => setReasonText(event.target.value)} />
            </fieldset>
            <LgyFormSubmit
                pristine={!reasonText}
                reset={() => setReasonText('')} />
        </form>
    </LgyModalDialog>
}

export default ReassignmentRequest